'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ./node_modules/querystring-es3/index.js
// module id = 760
// module chunks = 1